/**
 * Asynchronously loads the component for DealerInventoriesDetailsPage
 */

import { lazyLoad } from 'utils/loadable';

export const DealerInventoriesDetailsPage = lazyLoad(
  () => import('./index'),
  module => module.DealerInventoriesDetailsPage,
);
